import { API_CONSUMPTION_ENDPOINT } from '@/env';
import { provide } from '@/util/container';

import { CONSUMPTION_API_REST_CLIENT, KEYCLOAK } from '.';
import { createRestClient } from '../rest-client/rest-client';

export default provide(CONSUMPTION_API_REST_CLIENT, async (get) => {
  return createRestClient(await get(KEYCLOAK), API_CONSUMPTION_ENDPOINT);
});
